// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"e711359b","198":"0e8a48ed","551":"af59cc85"}[chunkId] + ".chunk.css";
};